import { render, staticRenderFns } from "./TopNav.vue?vue&type=template&id=2bf3de32&scoped=true"
import script from "./TopNav.vue?vue&type=script&lang=js"
export * from "./TopNav.vue?vue&type=script&lang=js"
import style0 from "./TopNav.vue?vue&type=style&index=0&id=2bf3de32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf3de32",
  null
  
)

export default component.exports